type PromptType =
  | 'template_rating'
  | 'memory_nudge'
  | 'notification_value'
  | 'store_review';

type PromptLock = {
  promptType: PromptType;
  expiresAtMs: number;
};

const DEFAULT_LOCK_MS = 90_000;
let activePromptLock: PromptLock | null = null;

const now = () => Date.now();

const cleanupExpiredLock = () => {
  if (!activePromptLock) return;
  if (activePromptLock.expiresAtMs <= now()) {
    activePromptLock = null;
  }
};

export const acquirePromptLock = (
  promptType: PromptType,
  lockMs: number = DEFAULT_LOCK_MS,
): boolean => {
  cleanupExpiredLock();
  if (activePromptLock) {
    return false;
  }
  activePromptLock = {
    promptType,
    expiresAtMs: now() + Math.max(10_000, lockMs),
  };
  return true;
};

export const releasePromptLock = (promptType: PromptType): void => {
  cleanupExpiredLock();
  if (!activePromptLock) return;
  if (activePromptLock.promptType !== promptType) return;
  activePromptLock = null;
};

export const getActivePromptType = (): PromptType | null => {
  cleanupExpiredLock();
  return activePromptLock?.promptType ?? null;
};
